<div
  *ngIf="options$ | async as options"
  class="html-template {{ styleType }}"
  [class.animated]="animated$ | async"
  [class.mirroredColumns]="isColumnMirrored"
  [class.largeImageStyle]="isLargeImageStyle"
  [style.background]="isPrintView ? this.printBackgroundColor : options.backgroundColor"
  [style.backgroundImage]="isPrintView ? '' : options.backgroundImage"
  libHtmlTemplate
  [globalScreenSize]="screenSize"
  [responsive]="responsive"
  [isPrintView]="isPrintView"
  [titleText]="options.titleText"
  [descriptionText]="options.subtitleText"
  [printBackgroundColor]="printBackgroundColor"
  [isTextFitEnabled]="true">
  <div class="template-wrapper">
    <div class="template-header">
      <img
        *ngIf="!isNoneLogoTemplate"
        alt=""
        [src]="options.logoUrl"
        class="template-logo"
        (load)="onLogoLoaded()"
        (error)="onLogoError(options.logoUrl)">
    </div>

    <div class="template-content">
      <div class="template-column column-main">
        <div *ngIf="options.titleText || options.subtitleText" class="template-content-header">
          <h1 class="template-title" [style.color]="options.titleColor + '!important'">
            {{ options.titleText }}
          </h1>

          <span class="template-desc" [style.color]="options.subtitleColor">
            {{ options.subtitleText }}
          </span>
        </div>

        <img
          *ngIf="!isNoQrCodeStyle && !isNoImageStyle && !isSwappedQrCodeImageStyle"
          alt=""
          [src]="options.qrCodeUrl"
          class="template-qr-code template-media"
          (load)="onQrCodeLoaded()"
          (error)="onQrCodeError(options.qrCodeUrl)">

        <img
          *ngIf="isSwappedQrCodeImageStyle && options.imageUrl"
          alt=""
          [src]="options.imageUrl"
          class="template-main-img template-media"
          (load)="onMainImageLoaded()"
          (error)="onMainImageError(options.imageUrl)">

        <span class="template-action-text" [style.color]="options.actionColor">
          {{ options.actionText }}
        </span>
      </div>

      <div class="template-column column-media">
        <img
          *ngIf="!isNoImageStyle && !isSwappedQrCodeImageStyle && options.imageUrl"
          alt=""
          [src]="options.imageUrl"
          class="template-main-img template-media"
          [class.large-img]="isLargeImageStyle"
          (load)="onMainImageLoaded()"
          (error)="onMainImageError(options.imageUrl)">

        <img
          *ngIf="isNoImageStyle || isSwappedQrCodeImageStyle"
          alt=""
          [src]="options.qrCodeUrl"
          class="template-qr-code template-media"
          (load)="onQrCodeLoaded()"
          (error)="onQrCodeError(options.qrCodeUrl)">

        <button
          *ngIf="options.buttonText"
          class="template-action-btn"
          [style.background]="options.buttonBackgroundColor">
          <span [style.color]="options.buttonTextColor">
            {{ options.buttonText }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
